import React, { useEffect, useState } from 'react'
import OrderCard from './OrderCard'
import { Col, Row } from 'reactstrap'
import firebase from "../../firebase/firebase-config";
import './TotalOrders.css';

const TotalOrders = () => {
    const [all_orders, setall_orders] = useState([])
    const [all_pendingorders, setall_pendingorders] = useState([])
    const [all_Approvedorders, setall_Approvedorders] = useState([])
    const [all_Productionorders, setall_Productionorders] = useState([])
    const [all_OFDorders, setall_OFDorders] = useState([])
    const [all_Deliveredorders, setall_Deliveredorders] = useState([])
    const [query, setquery] = useState('')
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };



    const get_all_orders = () => {
        firebase.firestore().collection('orders').onSnapshot((order) => {
            const orders_data = [];
            order.forEach(element => {
                orders_data.push(element.data());
            })
            setall_orders(orders_data);

        })
        firebase.firestore().collection('orders').where('status', '==', 'pending').onSnapshot((order) => {
            const Pendingorders_data = [];
            order.forEach(element => {
                Pendingorders_data.push(element.data());
            });
            setall_pendingorders(Pendingorders_data);

        })
        firebase.firestore().collection('orders').where('status', '==', 'approved').onSnapshot((order) => {
            const Approvedorders_data = [];
            order.forEach(element => {
                Approvedorders_data.push(element.data());
            });
            // console.log(Approvedorders_data);
            setall_Approvedorders(Approvedorders_data);

        })

        firebase.firestore().collection('orders').where('status', '==', 'production').onSnapshot((order) => {
            const Productionorders_data = [];
            order.forEach(element => {
                Productionorders_data.push(element.data());
            });
            // console.log(Approvedorders_data);
            setall_Productionorders(Productionorders_data);

        })
        firebase.firestore().collection('orders').where('status', '==', 'shipped').onSnapshot((order) => {
            const OFDorders_data = [];
            order.forEach(element => {
                OFDorders_data.push(element.data());
            });
            // console.log(Approvedorders_data);
            setall_OFDorders(OFDorders_data);

        })
        firebase.firestore().collection('orders').where('status', '==', 'delivered').onSnapshot((order) => {
            const Deliveredorders_data = [];
            order.forEach(element => {
                Deliveredorders_data.push(element.data());
            });
            // console.log(Approvedorders_data);
            setall_Deliveredorders(Deliveredorders_data);

        })


    }
    useEffect(() => {
        get_all_orders();
    }, []);

    const search = (data) => {
        return data.filter((order_search) => order_search.orderId.toLowerCase().includes(query) || order_search.isCompleted.toLowerCase().includes(query) || order_search.products.toLowerCase().includes(query) || order_search.contact.toLowerCase().includes(query)

        );
    }
    return (
        <>
            <div className="content">
                <Row>
                    <Col xs="12">

                        <div className="row  d-flex justify-content-center align-items-center">

                            <div className="col-md-6">

                                <div className="form" style={{ position: 'relative' }}>
                                    {query == '' ? <i className="fa fa-search" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i> : <i className="fa fa-close" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i>}

                                    <input type="text" className="form-control form-input" placeholder="Search any Order..." value={query} onChange={(e) => setquery(e.target.value)} style={{
                                        height: '55px',
                                        textIndent: '33px',
                                        borderRadius: '10px'
                                    }} />
                                    <span className="left-pan" style={{
                                        position: 'absolute',
                                        right: '17px',
                                        top: '13px',
                                        padding: '2px',
                                        borderLeft: '1px solid #d1d5db',
                                    }}>
                                        {query == '' ?
                                            <i className="fa fa-microphone" style={{ paddingLeft: '10px' }}></i> : <i className="fa fa-search" style={{ paddingLeft: '10px' }}></i>}</span>

                                </div>

                            </div>

                        </div>


                    </Col>
                </Row>
                <Row className="d-flex justify-content-center  mt-4 align-items-center">
                    <button
                        className={toggleState === 1 ? "tabs active-tabs btn btn-primary btn-sm" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(1)}
                    >
                        Total Orders({all_orders.length})
                    </button>
                    <button
                        className={toggleState === 2 ? "tabs active-tabs btn btn-sm btn-primary" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(2)}
                    >
                        Pending Orders({all_pendingorders.length})
                    </button>
                    <button
                        className={toggleState === 3 ? "tabs active-tabs btn-sm btn btn-primary" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(3)}
                    >
                        Approved Orders({all_Approvedorders.length})
                    </button>
                    <button
                        className={toggleState === 4 ? "tabs active-tabs btn btn-sm btn-primary" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(4)}
                    >
                        Production Orders({all_Productionorders.length})
                    </button>
                    <button
                        className={toggleState === 5 ? "tabs active-tabs btn-sm btn btn-primary" : "tabs btn btn-sm btn-default"}
                        onClick={() => toggleTab(5)}
                    >
                        Out For Delivery Orders({all_OFDorders.length})
                    </button>
                    <button
                        className={toggleState === 6 ? "tabs active-tabs btn-sm btn btn-primary" : "tabs btn btn-sm btn-default"}
                        onClick={() => toggleTab(6)}
                    >
                        Delivered Orders({all_Deliveredorders.length})
                    </button>
                </Row>

                <div className='mt-4'>
                    <div className="content-tabs">
                        <div className={toggleState === 1 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {all_orders.filter(order => order.orderId.toLowerCase().includes(query)).map((order, i) => (


                                    <OrderCard data={order} key={i} />


                                ))}
                            </div>



                        </div>
                        <div className={toggleState === 2 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {all_pendingorders.filter(order => order.orderId.toLowerCase().includes(query)).map((order, i) => (


                                    <OrderCard data={order} key={i} />


                                ))}
                            </div>
                        </div>
                        <div className={toggleState === 3 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {all_Approvedorders.filter(order => order.orderId.toLowerCase().includes(query)).map((order, i) => (


                                    <OrderCard data={order} key={i} />


                                ))}
                            </div>
                        </div>
                        <div className={toggleState === 4 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {all_Productionorders.filter(order => order.orderId.toLowerCase().includes(query)).map((order, i) => (


                                    <OrderCard data={order} key={i} />


                                ))}
                            </div>
                        </div>
                        <div className={toggleState === 5 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {all_OFDorders.filter(order => order.orderId.toLowerCase().includes(query)).map((order, i) => (


                                    <OrderCard data={order} key={i} />


                                ))}
                            </div>
                        </div>
                        <div className={toggleState === 6 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {all_Deliveredorders.filter(order => order.orderId.toLowerCase().includes(query)).map((order, i) => (


                                    <OrderCard data={order} key={i} />


                                ))}
                            </div>
                        </div>
                    </div>

                </div>


            </div>

        </>
    )
}

export default TotalOrders